import React from 'react'

import clsx from 'clsx'

import classes from './ContentReadOn.module.scss'

/** @type {import('./types').default} */
const ContentReadOn = ({ title, children }) => (
  <div className={clsx('ContentReadOn', classes.root)}>
    <h3 className={classes.title}>{title}</h3>
    <div className={classes.content}>{children}</div>
  </div>
)

export default ContentReadOn
